import { Box, Col, Text } from '@opendoor/bricks-next';
import type { EntryComponent } from 'cms/entries/entries';
import type { ILpComponentStatGrid } from 'declarations/contentful';

import Container from './shared/Container';

const TILE_ROW_RESPONSIVE = { flexDirection: 'row', flexWrap: 'wrap' } as const;

const TILE_TABLET = { flexBasis: '46%', flexGrow: 1 } as const;

const TILE_DESKTOP = { flexBasis: 0, flexGrow: 1 } as const;

const VALUE_RESPONSIVE = { typography: '$headerMedium' } as const;

interface StatGridItemsProps {
  items: NonNullable<ILpComponentStatGrid['fields']['items']>;
}

const StatGridItems = ({ items }: StatGridItemsProps) => {
  return (
    <>
      {items.map((stat, i) => (
        <Col
          key={stat.sys?.id ?? i}
          gap="$3x"
          minWidth="$80x"
          $largerThanSM={TILE_TABLET}
          $largerThanMD={TILE_DESKTOP}
        >
          <Text
            tag="p"
            typography="$displaySmall"
            fontWeight="$medium"
            color="$contentPrimary"
            $smallerThanMD={VALUE_RESPONSIVE}
            display="block"
          >
            {stat.fields.value}
          </Text>
          <Text tag="p" typography="$bodyMedium" color="$contentTertiary" display="block">
            {stat.fields.description}
          </Text>
        </Col>
      ))}
    </>
  );
};

const renderStatGrid = (entry: ILpComponentStatGrid) => {
  const { items } = entry.fields;
  if (!items?.length) return null;

  return (
    <Container noSectionSpacing paddingVertical="$16x">
      <Box flexDirection="column" gap="$12x" $largerThanSM={TILE_ROW_RESPONSIVE}>
        <StatGridItems items={items} />
      </Box>
    </Container>
  );
};

const StatGrid: EntryComponent<ILpComponentStatGrid> = {
  render: renderStatGrid,
};

export default StatGrid;
